import { render, staticRenderFns } from "./AgendaEmbed.vue?vue&type=template&id=5f936769&scoped=true&"
import script from "./AgendaEmbed.vue?vue&type=script&lang=js&"
export * from "./AgendaEmbed.vue?vue&type=script&lang=js&"
import style0 from "./AgendaEmbed.vue?vue&type=style&index=0&id=5f936769&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f936769",
  null
  
)

export default component.exports